import { createContext } from "react";

const ShipmentConceptContext = createContext();

export default ShipmentConceptContext;
